import { Link, useNavigate } from "react-router-dom";
import { X, ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "@/context/CartContext";
import Bag from "@/components/cart/Bag";

const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;

export default function CartDrawer() {
    const { bags, removeItem, subtotal, open, setOpen, count } = useCart();
    const navigate = useNavigate();

    if (!open) return null;
    const go = (to) => { setOpen(false); navigate(to); };

    return (
        <div className="fixed inset-0 z-[60]" data-testid="cart-drawer">
            <div className="absolute inset-0 bg-black/70 animate-fade-in" onClick={() => setOpen(false)} />
            <div className="absolute right-0 top-0 flex h-full w-full max-w-md flex-col border-l border-white/10 bg-brand-ink animate-slide-in-right">
                <div className="flex items-center justify-between border-b border-white/10 p-5">
                    <h3 className="flex items-center gap-2 font-display text-xl font-bold">
                        <ShoppingBag size={20} /> Your cart <span className="text-zinc-500">({count})</span>
                    </h3>
                    <button onClick={() => setOpen(false)} className="text-zinc-400 hover:text-white" data-testid="cart-close"><X /></button>
                </div>

                <div className="flex-1 overflow-y-auto p-5">
                    {bags.length === 0 ? (
                        <div className="flex h-full flex-col items-center justify-center text-center">
                            <ShoppingBag size={40} className="text-zinc-700" />
                            <p className="mt-4 font-semibold">Your cart is empty.</p>
                            <p className="mt-1 text-sm text-zinc-400">Browse a shop and add something.</p>
                            <button onClick={() => go("/directory")} className="mt-5 rounded-full bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-black"
                                data-testid="cart-walk-cta">
                                Browse shops
                            </button>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            {bags.length > 1 && (
                                <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500" data-testid="cart-multi-shop-note">
                                    Items from {bags.length} shops · each shop is paid separately
                                </p>
                            )}
                            {bags.map((bag) => <Bag key={bag.slug} bag={bag} onRemove={removeItem} expanded />)}
                        </div>
                    )}
                </div>

                {bags.length > 0 && (
                    <div className="border-t border-white/10 p-5">
                        <div className="mb-4 flex items-center justify-between text-sm text-zinc-400">
                            <span>{bags.length > 1 ? `Total for all ${bags.length} shops` : "Total"}</span><span className="font-mono text-white">{money(subtotal)}</span>
                        </div>
                        <button onClick={() => go(bags.length === 1 ? `/checkout/${bags[0].slug}` : "/cart")} data-testid="cart-checkout-button"
                            className="flex w-full items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold uppercase tracking-wide text-black transition-transform hover:scale-[1.02]">
                            {bags.length === 1 ? "Check out" : "Go to cart"} <ArrowRight size={16} />
                        </button>
                        <p className="mt-3 text-center text-[11px] text-zinc-500">
                            <Link to="/directory" onClick={() => setOpen(false)} className="hover:text-white">Keep shopping →</Link>
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}
